import React, { useState, useContext } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';

import { RequestReviewDocumentNoteFormValues } from '../../../../App/models/RequestReviewDocumentNote'
import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import TextAreaInput from '../../../../App/common/form/TextAreaInput';
import SelectInput from '../../../../App/common/form/SelectInput';

import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthLessThan
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'

const validate = combineValidators({
  requestReviewDocumentId: isRequired('requestReviewDocumentId'),
  noteType: isRequired('noteType'),
  note: composeValidators(
    isRequired('note'),
    hasLengthLessThan(300)({ message: 'Notes have a 300 char limit' })
  )(),
});

interface NoteParams {
  requestReviewDocumentId: string;
  requestReviewDocumentNoteId: string;
  noteType: string;
  note: string;
  requestReviewId: string;
}


const RequestReviewDocumentNoteForm: React.FC<NoteParams> = (match) => {
  const rootStore = useContext(RootStoreContext);
  const { loadRequestReviewDocuments } = rootStore.requestReviewDocumentStore;

  const { createRequestReviewDocumentNote, submitting } = rootStore.requestReviewDocumentNoteStore;

  const { getNoteOptions } = rootStore.commonStore;
  const { closeModal } = rootStore.modalStore;

  const [requestNote] = useState(new RequestReviewDocumentNoteFormValues(match.requestReviewDocumentId));
  requestNote.note = match.note;
  requestNote.id = match.requestReviewDocumentNoteId;
  requestNote.noteType = match.noteType;

  const [loading] = useState(false);

  const handleFinalFormSubmit = (values: any) => {
    const { ...requestReviewDocumentNote } = values;
    createRequestReviewDocumentNote(requestReviewDocumentNote)
      .then(r => loadRequestReviewDocuments(match.requestReviewId));
  };


  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={requestNote}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>

            <Field
              component={SelectInput}
              options={getNoteOptions(["Document"])}
              name='noteType'
              placeholder='NoteType'
              value={requestNote.noteType}
            />

            <Field
              rows={4}
              name='note'
              placeholder='Note'
              value={requestNote.note}
              component={TextAreaInput}
            />

            <Button
              loading={submitting}
              disabled={loading || invalid || pristine || submitting}
              floated='right'
              positive
              type='submit'
              content='Submit'
            />

            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(RequestReviewDocumentNoteForm);
